export default __webpack_public_path__ + "static/media/me3_yellow_WarningIcon.9f837b4f.svg";